import { render, staticRenderFns } from "./specific-pagination-com.vue?vue&type=template&id=59b55ec6&"
import script from "./specific-pagination-com.vue?vue&type=script&lang=js&"
export * from "./specific-pagination-com.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports